import { useState } from "react";
import { useDispatch } from "react-redux";

import { TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import { post } from "util/requests";
import "../signin/index.css";
import ctms_logo from "assets/ctms_logo.png";
import act_global_logo from "assets/act_global_logo.png";
import router from "routes";

const error_message = "Sorry, your login was not correct.";

const logo = window.location.hostname.includes("actglobaltrial.com") ? act_global_logo : ctms_logo;

export default function PasswordResetUnathenticated() {
  const [is_loading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [show2fa, setShow2fa] = useState(false);
  const [email, setEmail] = useState("");
  const [isSent, setIsSent] = useState(false);

  const emailvalid = (value) =>
    value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.trim()) ? true : false;

  const handleReset = () => {
    if (is_loading) return;

    if (!emailvalid(email)) {
      return;
    }
    setIsLoading(true);
    post("/reset_password", { email }).then(() => {
      setIsLoading(false);
      setIsSent(true);
    });
  };

  const handleFieldChange = (key) => (e) => {
    if (key === "email") setEmail(e.target.value);
    else if (key === "password") setPassword(e.target.value);
    setErrorMessage(null);
  };

  const onKeyDown = (key) => {
    if (key.key === "Enter") {
      handleReset();
    }
  };

  return (
    <div className="wrapper">
      {!isSent ? (
        <div className="login-card">
          <img src={logo} width="400px" className="logo" />
          <h2 style={{ color: "#333" }}>Reset Your Password</h2>
          <div className="margin-b-1">
            <TextField label="Email" variant="standard" onChange={handleFieldChange("email")} onKeyDown={onKeyDown} />
          </div>

          <LoadingButton variant="contained" loading={is_loading} onClick={handleReset}>
            RESET PASSWORD
          </LoadingButton>
          {errorMessage ? <div>{errorMessage}</div> : null}
        </div>
      ) : (
        <div className="login-card">
          <img src={logo} width="400px" className="logo" />

          <div style={{ marginTop: 40 }}>We've sent you a reset link. Please check your email.</div>
          <LoadingButton
            variant="contained"
            loading={is_loading}
            onClick={() => router.navigate("/")}
            style={{ width: 200, alignSelf: "center", marginTop: 20 }}
          >
            SIGN IN
          </LoadingButton>
        </div>
      )}
    </div>
  );
}
